import { NavLink } from "react-router-dom"
import { useState } from "react"
import '../../styles/ui/nav.scss'
import useWindowDimensions from "../utility/DimensionTracker"
const Nav = () => {

    const [isOpen, setOpen] = useState(false)
    const { height, width } = useWindowDimensions();

    return (
        <div className="nav-wrapper">
            <nav
                className={`nav-container ${width <= 1600 && "mobile"}`}
            >
                {
                    width <= 1600 &&
                    <div className='button-wrapper'>
                        <button className={`${isOpen ? 'menu-button-open' : 'menu-button-close'}`}
                            onClick={()=>{
                                setOpen(!isOpen)
                            }}
                        >
                            <div className="hamburger-line-1"></div>
                            <div className="hamburger-line-2"></div>
                            <div className="hamburger-line-3"></div>
                        </button>
                    </div>
                }
                <div className={width <= 1600 ? 'nav-list-mobile' : 'nav-list'}>
                    <div className={`${width <= 1600 ? isOpen ? 'open-nav' : 'closed-nav' : 'regular-nav'}`}>
                        <NavLink to="/" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Top
                        </NavLink>
                        <NavLink to="/character" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Characters
                        </NavLink>
                        <NavLink to="/system" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            System
                        </NavLink> 
                        <NavLink to="/field-notes" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Field Notes
                        </NavLink>
                        <NavLink to="/world" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            World
                        </NavLink>
                        <NavLink to="/fanart/pet-department" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Fan Art
                        </NavLink>
                        <NavLink to="/products" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Products
                        </NavLink>
                        <NavLink to="/gallery" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Gallery
                        </NavLink>
                        {/* <NavLink to="/contest" className={({isActive})=>isActive ? 'active-link' : 'inactive' }
                            onClick={()=>{
                                setOpen(false)
                            }}
                        >
                            Contest
                        </NavLink> */}
                    </div>
                </div>
            </nav>
        </div>
    )
}

export default Nav;